<template>
    <div class="d-flex flex-wrap mt-2 container">
      <!-- <div class="container mb-2">
        <v-divider class="mx-4" color="black"></v-divider>
        <h1 class="text-center display-3 font-weight-light mt-2 mb-2">
          Neue Gerichte
        </h1>
        <v-divider class="mx-4 mb-6" color="black"></v-divider>
        <backtohome></backtohome>
      </div> -->
      <v-row>
        <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in chickenwings"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Chicken Wings
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            <!-- (10 Stk.)<br /> -->
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in chickenbites"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Mini Chicken Bites 
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            <!-- (2 Stk.)<br /> -->
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in chickenmix"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Chicken Mix
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            <!-- (2 Stk.)<br /> -->
            12,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  // import Backtohome from './Backtohome.vue';
  export default {
    // components: { Backtohome },
    data() {
      return {
        chickenbites: [
        {
          src: require('../assets/images/chickenbites.jpg'),
        },
      ],
      chickenwings: [
        {
          src: require('../assets/images/chickenwings.jpg'),
        },

      ],
      chickenmix: [
        {
          src: require('../assets/images/chickenmix.jpg'),
        },
      ],
      };
    },
    methods: {
      top() {
        window.scrollTo(0, 0);
      },
    },
    created() {
      this.top();
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  